"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Composes multiple providers, applying them in reverse order.
 * Allows passing props to each provider.
 *
 * @example
 * providers={[
 *   ThemeProvider, // no props
 *   [AuthProvider, { user: ... }],
 *   [CartProvider, { cartId: 'abc' }],
 * ]
 */
function ComposeProviders(_ref) {
  let {
    providers,
    children
  } = _ref;
  return providers.reduceRight((acc, entry, index) => {
    const [Provider, providerProps] = Array.isArray(entry) ? entry : [entry, {}];
    try {
      const wrapped = /*#__PURE__*/_react.default.createElement(Provider, providerProps, acc);
      return wrapped;
    } catch (err) {
      console.error("[ComposeProviders] \u274C Failed to render ".concat(index, ":"), err);
      return acc;
    }
  }, children);
}
var _default = exports.default = ComposeProviders;